const popularAirports = [
	{
		"distance_in_miles": 14.02,
		"id": 5796,
		"name": "London Biggin Hill Airport (BQH)",
		"address": "Biggin Hill, England",
		"airport_code": "BQH",
		"lat": 51.3307991,
		"lng": 0.0325,
		"active": true,
		"type": "airport",
		"is_airport": 1
	},
	{
		"distance_in_miles": 8.78,
		"id": 5679,
		"name": "Paris-Le Bourget Airport (LBG)",
		"address": "Bonneuil-en-France, \u00cele-de-France",
		"airport_code": "LBG",
		"lat": 48.9693985,
		"lng": 2.44139004,
		"active": true,
		"type": "airport",
		"is_airport": 1
	},
	{
		"distance_in_miles": 4.25,
		"id": 5729,
		"name": "Nice-C\u00f4te d'Azur Airport (NCE)",
		"address": "Nice, Provence-Alpes-C\u00f4te d'Azur",
		"airport_code": "NCE",
		"lat": 43.65840149,
		"lng": 7.2158699,
		"active": true,
		"type": "airport",
		"is_airport": 1
	},
	{
		"distance_in_miles": 2.85,
		"id": 4987,
		"name": "Geneva Cointrin International Airport (GVA)",
		"address": "Le Grand-Saconnex, Gen\u00e8ve",
		"airport_code": "GVA",
		"lat": 46.23809814,
		"lng": 6.10895014,
		"active": true,
		"type": "airport",
		"is_airport": 1
	},
	{
		"distance_in_miles": 4.41,
		"id": 6230,
		"name": "Milano Linate Airport (LIN)",
		"address": "Linate, Lombardia",
		"airport_code": "LIN",
		"lat": 45.445099,
		"lng": 9.27674,
		"active": true,
		"type": "airport",
		"is_airport": 1
	},
]

export default popularAirports
